import Client from '@spike/client-model';
import { getClientThunk } from '@spike/clients-action';
import Pet from '@spike/pet-model';
import { fetchPetsThunk } from '@spike/pets-action';
import { useApiClientWrapper } from 'hooks';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';

// Client profile (tags, address) and pet profiles (breed, size, personalities) shown in the waitlist,
// loaded through the same store Add Appointment uses.
export const useWaitlistClientData = (customerId: number | undefined) => {
    const dispatch = useDispatch();
    const apiClientWrapper = useApiClientWrapper();

    const storedClient = useSelector<RootState, Client | undefined>(state => state.clients.client);
    const storedPets = useSelector<RootState, Array<Pet>>(state => state.pets.list);

    useEffect(() => {
        if (customerId === undefined) {
            return;
        }

        dispatch(getClientThunk(apiClientWrapper, customerId));
        dispatch(fetchPetsThunk(apiClientWrapper, customerId));
    }, [customerId]);

    // The store is shared with other screens: ignore a client loaded for someone else.
    // Pets are matched by id by the callers, so a stale list never shows another client's pet.
    const client = customerId !== undefined && storedClient?.id === customerId ? storedClient : undefined;

    return { client, pets: customerId !== undefined ? storedPets : [] };
};

export default useWaitlistClientData;
